/**
 * ekimall-wishlist-heart-pointed.js (v161)
 *
 * Magic Wishlist has TWO button surfaces:
 *   A) wishlist-heart.css → .wishlist-heart-btn { border-radius: 50%!important }
 *                         → .wishlist-heart-btn--alternate { 9999px!important }
 *   B) wishlist-btn.css   → .wishlist-btn { border-radius: 3.75px }  (PDP buy-buttons)
 *
 * v160 only targeted (A). Screenshot ~4–5px rounded heart on ABLY PDP is (B).
 *
 * v161: append runtime <style> last on documentElement (after app <link>),
 * plus one MutationObserver that sets border-radius:0 only when it is non-zero
 * (applying flag prevents write loops).
 */
(function () {
  'use strict';

  var STYLE_ID = 'ekimall-wishlist-heart-pointed-runtime';
  var SEL =
    '.wishlist-heart-btn, .wishlist-heart-btn--alternate, button.wishlist-heart-btn, ' +
    '.wishlist-btn, .wishlist-btn--icon-only, .wishlist-btn--plain, button.wishlist-btn';

  var CSS = [
    '/* ekimall v161 runtime — after Magic Wishlist CSS */',
    'html body .wishlist-heart-btn,',
    'html body .wishlist-heart-btn.wishlist-heart-btn,',
    'html body .wishlist-heart-btn--alternate,',
    'html body .wishlist-heart-btn.wishlist-heart-btn--alternate,',
    'html body .wishlist-heart-container .wishlist-heart-btn,',
    'html body .product-details .wishlist-heart-btn,',
    'html body .product-form-buttons .wishlist-heart-btn,',
    'html body .buy-buttons-block .wishlist-heart-btn,',
    'html body button.wishlist-heart-btn,',
    'html body [class*="wishlist-heart-btn"],',
    'html body .wishlist-btn,',
    'html body .wishlist-btn.wishlist-btn,',
    'html body .wishlist-btn--icon-only,',
    'html body .wishlist-btn--plain,',
    'html body .wishlist-btn-container .wishlist-btn,',
    'html body .wishlist-cart-flex .wishlist-btn,',
    'html body .wishlist-cart-flex .wishlist-btn--icon-only,',
    'html body .product-details .wishlist-btn,',
    'html body .product-form-buttons .wishlist-btn,',
    'html body .buy-buttons-block .wishlist-btn,',
    'html body button.wishlist-btn {',
    '  border-radius: 0 !important;',
    '  --border-radius: 0 !important;',
    '  --buttons-radius: 0px !important;',
    '  --style-border-radius-buttons: 0px !important;',
    '  --style-border-radius-buttons-primary: 0px !important;',
    '}',
    'html body .wishlist-heart-btn *,',
    'html body .wishlist-btn *,',
    'html body .wishlist-btn__icon,',
    'html body .wishlist-btn__icon svg { border-radius: 0 !important; }'
  ].join('\n');

  var applying = false;

  function ensureStylesheet() {
    var el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      el.textContent = CSS;
    }
    document.documentElement.appendChild(el);
  }

  function isRounded(el) {
    if (!el) return false;
    var inline = (el.style && el.style.borderRadius || '').trim();
    if (inline && inline !== '0' && inline !== '0px') return true;
    try {
      var br = (getComputedStyle(el).borderRadius || '').trim();
      if (!br || br === '0px') return false;
      return !/^0px(\s+0px)*$/.test(br);
    } catch (e) {
      return false;
    }
  }

  function point(el) {
    if (!el || el.nodeType !== 1) return;
    applying = true;
    try {
      el.style.setProperty('border-radius', '0px', 'important');
      el.style.setProperty('--border-radius', '0', 'important');
      el.style.setProperty('--buttons-radius', '0px', 'important');
      el.style.setProperty('--style-border-radius-buttons', '0px', 'important');
      el.setAttribute('data-ekimall-pointed', '1');
    } finally {
      requestAnimationFrame(function () { applying = false; });
    }
  }

  function sweep() {
    ensureStylesheet();
    document.querySelectorAll(SEL).forEach(function (el) {
      if (isRounded(el) || el.getAttribute('data-ekimall-pointed') !== '1') point(el);
    });
  }

  function boot() {
    ensureStylesheet();
    sweep();
    if (window.MutationObserver) {
      var scheduled = 0;
      new MutationObserver(function (mutations) {
        if (applying) return;
        var need = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'childList') { need = true; break; }
          if (m.type === 'attributes' && m.target && m.target.matches && m.target.matches(SEL) && isRounded(m.target)) {
            need = true; break;
          }
        }
        if (!need || scheduled) return;
        scheduled = requestAnimationFrame(function () {
          scheduled = 0;
          if (!applying) sweep();
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    window.addEventListener('load', function () {
      ensureStylesheet();
      sweep();
      setTimeout(sweep, 400);
      setTimeout(sweep, 1200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
